import { QueryHookOptions, useQuery } from '@apollo/client';

import { USER_BY_ID_QUERY_FOR_ECEC_LANDING } from './queries';
import { User } from './types';

export const useUserByIdForEcecLanding = (id: number | null, options?: QueryHookOptions) =>
  useQuery<{ user: User }>(USER_BY_ID_QUERY_FOR_ECEC_LANDING, { ...options, variables: { id } });
